import styled from 'styled-components';
import { breakpoints, palette, flexCenter } from '../../constants/styles';

export const HEADER_HEIGHT = 50;

export const FlowHeader = styled.div`
  ${flexCenter}
  position: fixed;
  top: 0;
  height: ${HEADER_HEIGHT}px;
  width: 100vw;
  padding-top: 5px;
  box-sizing: border-box;
  background-color: ${palette.primaryColor};
  z-index: 1000;
`;

export const StyledPane = styled.div`
  display: none;

  ${breakpoints.tablet} {
    display: block;
    margin-top: ${HEADER_HEIGHT}px;
    width: 20%;
    background-color: #f1f1f1;
    height: auto;
  }

  ${breakpoints.tabletLandscape} {
    width: 24%;
  }
`;

export const ReferenceRow = styled.li`
  margin-bottom: 3px;
`;

export const References = styled.ul`
  padding-left: 0px;
  margin: 0.3rem 0;
`;
